import dteBulkDownloadApi from '../../api/report/dteBulkDownloadApi';
import {
  DteBulkDownloadResult,
  SaleDteBulkDownloadRequest,
} from '../../types/reports/dteBulkDownload/SaleDteBulkDownloadRequest';

const DteBulkDownloadService = {
  prepare: async (
    request: SaleDteBulkDownloadRequest
  ): Promise<DteBulkDownloadResult> => {
    const response = await dteBulkDownloadApi.addCustom(
      '/dte-bulk-download/prepare',
      request
    );

    return response.data;
  },

  downloadStream: async (
    request: SaleDteBulkDownloadRequest
  ): Promise<DteBulkDownloadResult> => {
    const result = await dteBulkDownloadApi.downloadBlob(
      '/dte-bulk-download/stream',
      request,
      'documentos-dte.zip'
    );

    const rawCount = result.headers['x-document-count'];
    const count = rawCount === undefined ? undefined : Number(rawCount);

    return {
      mode: 'STREAMING',
      fileName: result.fileName,
      documentCount: Number.isFinite(count) ? count : undefined,
    };
  },

  download: async (
    request: SaleDteBulkDownloadRequest
  ): Promise<DteBulkDownloadResult> => {
    const decision = await DteBulkDownloadService.prepare(request);

    if (decision.mode === 'BACKGROUND_JOB') {
      return decision;
    }

    return DteBulkDownloadService.downloadStream(request);
  },
};

export default DteBulkDownloadService;